($ => {

    "use strict";

    const PANEL = "#cesta-orcamento-site";

    function panel() {
        return document.querySelector(PANEL);
    }

    function overlay() {
        return document.querySelector(".cesta-orcamento-site-overlay");
    }

    function trigger() {
        return document.querySelector("#site-header .btn-orcamento[data-cesta-open]");
    }

    function isOpen() {
        return Boolean(panel()?.classList.contains("is-open"));
    }

    function setOpen(open) {
        const root = panel();
        const veil = overlay();
        const button = trigger();
        if (!root) {
            return;
        }

        root.classList.toggle("is-open", open);
        root.setAttribute("aria-hidden", open ? "false" : "true");
        root.inert = !open;
        if (veil) {
            veil.hidden = !open;
            veil.classList.toggle("is-open", open);
        }
        button?.setAttribute("aria-expanded", open ? "true" : "false");
        document.body.classList.toggle("no-scroll", open);
        if (open) {
            root.querySelector("[data-cesta-close]")?.focus();
        }
    }

    function applyFromHtml(html) {
        const nextDoc = new DOMParser().parseFromString(String(html || ""), "text/html");
        const nextPanel = nextDoc.querySelector(PANEL);
        const current = panel();
        if (!nextPanel || !current) {
            return false;
        }
        const isFragment = nextPanel.hasAttribute("data-cesta-fragment");
        const isFullPage = Boolean(nextDoc.querySelector("#site-page"));
        if (!isFragment && isFullPage) {
            return false;
        }

        const wasOpen = isOpen();
        const list = current.querySelector("[data-cesta-list]");
        const nextList = nextPanel.querySelector("[data-cesta-list]");
        if (list && nextList) {
            list.innerHTML = nextList.innerHTML;
        }

        current.querySelectorAll("[data-cesta-count-label]").forEach((node, index) => {
            const source = nextPanel.querySelectorAll("[data-cesta-count-label]")[index];
            if (source) {
                node.textContent = source.textContent;
            }
        });
        current.querySelectorAll("[data-cesta-selected-label]").forEach((node, index) => {
            const source = nextPanel.querySelectorAll("[data-cesta-selected-label]")[index];
            if (source) {
                node.textContent = source.textContent;
            }
        });

        const count = Number(nextPanel.getAttribute("data-cesta-count") || "0");
        current.setAttribute("data-cesta-count", String(count));
        current.setAttribute("data-cesta-ids", nextPanel.getAttribute("data-cesta-ids") || "");
        current.classList.toggle("is-empty", count < 1);

        const cta = current.querySelector("[data-cesta-cta]");
        const nextCta = nextPanel.querySelector("[data-cesta-cta]");
        if (cta && nextCta) {
            cta.classList.toggle("is-disabled", nextCta.classList.contains("is-disabled"));
            if (nextCta.hasAttribute("aria-disabled")) {
                cta.setAttribute("aria-disabled", "true");
                cta.setAttribute("tabindex", "-1");
            } else {
                cta.removeAttribute("aria-disabled");
                cta.removeAttribute("tabindex");
            }
        }

        const nextBadge = nextDoc.querySelector("#site-header [data-cesta-badge]");
        const badge = document.querySelector("#site-header [data-cesta-badge]");
        if (badge) {
            setBadgeCount(badge, count);
        } else if (nextBadge && trigger()) {
            trigger().insertAdjacentHTML("beforeend", nextBadge.outerHTML);
        }

        const nextRail = nextDoc.querySelector(".sidebar-cesta-orcamento");
        const rail = document.querySelector(".sidebar-cesta-orcamento");
        if (nextRail && rail) {
            const nextRailList = nextRail.querySelector("[data-cesta-rail-list], .palestrantes-selecionados, .form-orcamento-rail-list");
            const railList = rail.querySelector(".palestrantes-selecionados, .form-orcamento-rail-list");
            if (nextRailList && railList) {
                railList.innerHTML = nextRailList.innerHTML;
            } else {
                rail.innerHTML = nextRail.innerHTML;
            }
            const nextCount = nextDoc.querySelector("[data-cesta-rail-count]");
            const railCount = rail.querySelector("[data-orcamento-count]");
            if (nextCount && railCount) {
                railCount.textContent = nextCount.textContent;
            }
        }

        if (wasOpen) {
            setOpen(true);
        }
        syncCestaMarks();
        return true;
    }

    function formatCountLabel(count) {
        return count === 1 ? "1 palestrante" : `${count} palestrantes`;
    }

    function formatSelectedLabel(count) {
        return count === 1 ? "1 palestrante selecionado" : `${count} palestrantes selecionados`;
    }

    function applyOptimisticAdd(speaker) {
        const current = panel();
        const id = Number(speaker?.id || 0);
        if (!current || id < 1 || cestaIds().has(id)) {
            return;
        }

        const list = current.querySelector("[data-cesta-list]");
        if (list && !list.querySelector(`.cesta-palestrante-site [data-id="${id}"]`)) {
            list.querySelector(".cesta-orcamento-site-empty")?.remove();
            list.insertAdjacentHTML("beforeend", `
                <article class="cesta-palestrante-site">
                    <a class="cesta-palestrante-site-media" href="${escapeHtml(speaker.url || "#")}">
                        <img src="${escapeHtml(speaker.img || "")}" width="56" height="56" alt="${escapeHtml(speaker.name || "")}" />
                    </a>
                    <div class="cesta-palestrante-site-copy">
                        <a href="${escapeHtml(speaker.url || "#")}">
                            <strong>${escapeHtml(speaker.name || "")}</strong>
                        </a>
                        ${speaker.specialty ? `<p>${escapeHtml(speaker.specialty)}</p>` : ""}
                    </div>
                    <button type="button" class="cesta-palestrante-site-remove btn-remover" data-id="${id}" aria-label="Remover">
                        Remover
                    </button>
                </article>
            `);
        }

        const ids = [...cestaIds(), id];
        const count = ids.length;
        current.setAttribute("data-cesta-count", String(count));
        current.setAttribute("data-cesta-ids", ids.join(","));
        current.classList.toggle("is-empty", count < 1);
        current.querySelectorAll("[data-cesta-count-label]").forEach((node) => {
            node.textContent = formatCountLabel(count);
        });
        current.querySelectorAll("[data-cesta-selected-label]").forEach((node) => {
            node.textContent = formatSelectedLabel(count);
        });

        const cta = current.querySelector("[data-cesta-cta]");
        if (cta) {
            cta.classList.remove("is-disabled");
            cta.removeAttribute("aria-disabled");
            cta.removeAttribute("tabindex");
        }

        const badge = document.querySelector("#site-header [data-cesta-badge]");
        if (badge) {
            setBadgeCount(badge, count);
        }

        const railList = document.querySelector(".sidebar-cesta-orcamento [data-cesta-rail-list], .sidebar-cesta-orcamento .palestrantes-selecionados, .form-orcamento-rail-list");
        if (railList && !railList.querySelector(`[data-id="${id}"]`)) {
            railList.querySelector(".form-orcamento-empty")?.remove();
            railList.insertAdjacentHTML("beforeend", `
                <article class="cesta-palestrante-site">
                    <strong>${escapeHtml(speaker.name || "")}</strong>
                    <button type="button" class="btn-remover" data-id="${id}" aria-label="Remover">Remover</button>
                </article>
            `);
        }
        const railCount = document.querySelector("[data-orcamento-count]");
        if (railCount) {
            railCount.textContent = count > 0 ? `${count} no orçamento` : "Nenhum ainda";
        }

        syncCestaMarks();
    }

    function picker() {
        return document.getElementById("cesta-pick-dialog");
    }

    function isPickerOpen() {
        return Boolean(picker()?.open);
    }

    function cestaIds() {
        const raw = panel()?.getAttribute("data-cesta-ids") || "";
        return new Set(
            raw.split(",")
                .map((value) => Number(value))
                .filter((value) => value > 0)
        );
    }

    /** O número do selo fica fora da árvore de acessibilidade (aria-hidden): a contagem vai no nome do botão. */
    function setBadgeCount(badge, count) {
        badge.textContent = count > 0 ? String(count) : "";
        badge.hidden = count < 1;
        const button = badge.closest(".btn-orcamento");
        if (button) {
            const base = button.dataset.labelBase || (button.dataset.labelBase = (button.getAttribute("aria-label") || "").replace(/\s*\(\d+\)$/, ""));
            button.setAttribute("aria-label", count > 0 ? `${base} (${count})` : base);
        }
    }

    function syncCestaMarks() {
        const ids = cestaIds();
        document.querySelectorAll("[data-add-orcamento][data-palestrante-id]").forEach((button) => {
            const id = Number(button.getAttribute("data-palestrante-id"));
            const inCesta = ids.has(id);
            const addLabel = button.getAttribute("data-add-label") || "";
            const inLabel = button.getAttribute("data-in-cesta-label") || addLabel;
            const label = inCesta ? inLabel : addLabel;
            button.classList.toggle("is-in-cesta", inCesta);
            button.disabled = inCesta;
            button.setAttribute("aria-pressed", inCesta ? "true" : "false");
            if (label) {
                button.setAttribute("aria-label", label);
                button.setAttribute("title", label);
            }
            button.closest(".card-palestrante-site, .card-palestrante-portrait")
                ?.classList.toggle("is-in-cesta", inCesta);
        });
    }

    function escapeHtml(value) {
        return String(value || "").replace(/[&<>"']/g, (char) => ({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            "\"": "&quot;",
            "'": "&#039;",
        })[char]);
    }

    function pickerCardsUrl(termo, page = 1) {
        const dialog = picker();
        const url = new URL(dialog?.dataset.cardsUrl || "/palestrantes", window.location.origin);
        url.searchParams.set("fragment", "cards");
        if (Number(page) > 1) {
            url.searchParams.set("pagina", String(page));
        } else {
            url.searchParams.delete("pagina");
        }
        const query = String(termo || "").trim();
        if (query) {
            url.searchParams.set("termo", query);
        } else {
            url.searchParams.delete("termo");
        }
        return url;
    }

    async function loadPicker(termo, { page = 1, append = false } = {}) {
        const results = document.querySelector("[data-cesta-pick-results]");
        if (!results) {
            return false;
        }
        const loading = results.getAttribute("data-loading") || "Carregando palestrantes…";
        const empty = results.getAttribute("data-empty") || "Nenhum palestrante encontrado.";
        results.setAttribute("aria-busy", "true");
        if (!append) {
            results.innerHTML = `<p class="cesta-pick-status">${escapeHtml(loading)}</p>`;
        }
        try {
            const response = await fetch(pickerCardsUrl(termo, page).toString(), {
                headers: { "X-Requested-With": "XMLHttpRequest" },
            });
            if (!response.ok) {
                throw new Error("cesta-pick-failed");
            }
            const html = (await response.text()).trim();
            const wrapper = document.createElement("div");
            wrapper.innerHTML = html;
            const cards = [...wrapper.querySelectorAll(".card-palestrante-site")];
            const nextMore = wrapper.querySelector(".cesta-pick-load-more");
            if (!append) {
                results.replaceChildren();
                if (!cards.length) {
                    results.innerHTML = `<p class="cesta-pick-status">${escapeHtml(empty)}</p>`;
                    return true;
                }
                cards.forEach((card) => results.appendChild(card));
                if (nextMore) {
                    results.appendChild(nextMore);
                }
                return true;
            }

            const currentMore = results.querySelector(".cesta-pick-load-more");
            currentMore?.remove();
            cards.forEach((card) => results.appendChild(card));
            if (nextMore) {
                results.appendChild(nextMore);
            }
            return true;
        } catch (_error) {
            if (!append) {
                results.innerHTML = `<p class="cesta-pick-status">${escapeHtml(empty)}</p>`;
            }
            return false;
        } finally {
            results.removeAttribute("aria-busy");
            syncCestaMarks();
        }
    }

    function openPicker() {
        const dialog = picker();
        if (!dialog || typeof dialog.showModal !== "function") {
            window.location.assign(dialog?.dataset.catalogUrl || "/palestrantes");
            return;
        }
        if (!dialog.open) {
            dialog.showModal();
        }
        const input = dialog.querySelector("[data-cesta-pick-q]");
        loadPicker(input?.value || "");
        window.setTimeout(() => input?.focus(), 0);
    }

    function closePicker() {
        const dialog = picker();
        if (dialog?.open) {
            dialog.close();
        }
    }

    let pickTimer = 0;

    $(document).on("click", "[data-cesta-open]", function (event) {
        event.preventDefault();
        setOpen(!isOpen());
    });

    $(document).on("click", "[data-cesta-close]", function (event) {
        event.preventDefault();
        setOpen(false);
    });

    document.addEventListener("submit", (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute("data-cesta-pick-form")) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        const query = form.querySelector("[data-cesta-pick-q]")?.value || "";
        loadPicker(query);
    }, true);

    $(document).on("click", "[data-cesta-cta].is-disabled", function (event) {
        event.preventDefault();
    });

    $(document).on("click", "[data-cesta-pick]", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openPicker();
    });

    document.addEventListener("click", (event) => {
        const link = event.target instanceof Element ? event.target.closest("[data-cesta-pick]") : null;
        if (!link) {
            return;
        }
        event.preventDefault();
    }, true);

    $(document).on("click", "[data-cesta-pick-close]", function (event) {
        event.preventDefault();
        closePicker();
    });

    $(document).on("click", "[data-cesta-pick-page]", function () {
        closePicker();
    });

    $(document).on("submit", "[data-cesta-pick-form]", function (event) {
        event.preventDefault();
        const query = this.querySelector("[data-cesta-pick-q]")?.value || "";
        loadPicker(query);
    });

    $(document).on("input", "[data-cesta-pick-q]", function () {
        const query = this.value;
        window.clearTimeout(pickTimer);
        pickTimer = window.setTimeout(() => loadPicker(query), 280);
    });

    $(document).on("click", "[data-cesta-pick-load-more]", async function (event) {
        event.preventDefault();
        const button = this;
        const dialog = picker();
        const input = dialog?.querySelector("[data-cesta-pick-q]");
        const nextPage = Number(button.dataset.page) + 1;
        const totalPages = Number(button.dataset.totalPages);
        if (!nextPage || nextPage > totalPages) {
            button.closest(".cesta-pick-load-more")?.remove();
            return;
        }

        const label = button.textContent;
        button.disabled = true;
        button.textContent = button.dataset.loadingText || label;
        const loaded = await loadPicker(input?.value || "", { page: nextPage, append: true });
        if (!loaded && document.body.contains(button)) {
            button.disabled = false;
            button.textContent = label;
        }
    });

    $(document).on("click", "#cesta-pick-dialog", function (event) {
        if (event.target === this) {
            closePicker();
        }
    });

    $(document).on("click", ".cesta-palestrante-site .btn-remover", async function () {
        const button = this;
        const palestranteId = parseInt(button.getAttribute("data-id"), 10) || 0;
        const buttons = document.querySelectorAll(".cesta-palestrante-site .btn-remover");
        try {
            buttons.forEach((item) => {
                item.disabled = true;
            });
            const responseHTML = await ServerActions.getGlobal("remove_palestrante_orcamento", {
                pid: palestranteId,
                fragment: "cesta",
            });
            Events.dispatch(ServerEvents.REMOVE_PALESTRANTE_ORCAMENTO, [responseHTML]);
        } catch (_error) {
            UIMessages.error("Erro ao remover palestrante da cesta.", PANEL);
        } finally {
            buttons.forEach((item) => {
                item.disabled = false;
            });
        }
    });

    window.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") {
            return;
        }
        if (isPickerOpen()) {
            return;
        }
        if (isOpen()) {
            setOpen(false);
        }
    }, true);

    Events.listen(ServerEvents.ADD_PALESTRANTE_ORCAMENTO, (_event, dataHTML, options = {}) => {
        if (!panel()) {
            return;
        }
        const silent = Boolean(options && options.silent);
        const updated = applyFromHtml(dataHTML);
        if (updated && !isPickerOpen() && !silent) {
            setOpen(true);
        }
    });

    Events.listen(ServerEvents.REMOVE_PALESTRANTE_ORCAMENTO, (_event, dataHTML) => {
        if (!panel()) {
            return;
        }
        applyFromHtml(dataHTML);
    });

    document.addEventListener("site:cesta-open", () => setOpen(true));
    document.addEventListener("site:cesta-optimistic-add", (event) => {
        applyOptimisticAdd(event.detail || {});
    });
    document.addEventListener("site:navigated", syncCestaMarks);
    document.addEventListener("site:cesta-sync", syncCestaMarks);
    window.siteReady(syncCestaMarks);

})(jQuery);
